import { useInterestQuestionariesTemplateConfiguration } from "PFApp/hooks";
import { Activity, Template } from "PFCore/types";
import { useCallback } from "react";

type UseInitialQuestionsValuesParams = {
  template: Template;
};

type GetInitialQuestionsValuesParams = {
  inheritFromActivity: boolean;
  isClone: boolean;
  activity: Activity;
};

export const useInitialQuestionsValues = ({ template }: UseInitialQuestionsValuesParams) => {
  const templateConfig = useInterestQuestionariesTemplateConfiguration(template);

  const getInitialQuestionsValues = useCallback(
    ({ isClone, inheritFromActivity, activity }: GetInitialQuestionsValuesParams) => {
      const initialQuestionsValues: string[] = [1, 2, 3].map((id) => {
        const activityQuestion = activity.metadata?.interest_questions?.[id - 1];
        if (inheritFromActivity) {
          return activityQuestion || "";
        }

        const areQuestionsProvidedInActivity = !!activity.metadata?.interest_questions;
        if (isClone && areQuestionsProvidedInActivity) {
          return activityQuestion || "";
        }

        return templateConfig?.[`question${id}`] || "";
      });

      const initialQuestionsToggleValue =
        isClone || inheritFromActivity
          ? !!activity.metadata?.interest_questions
          : !!templateConfig?.showQuestions;

      return {
        initialQuestionsValues,
        initialQuestionsToggleValue
      };
    },
    [templateConfig]
  );

  return { getInitialQuestionsValues };
};
